import { Table } from '@/components'
import { useTableColumns } from '@/hooks'
import { DpObjectContent } from '@/pages/User/pages/Home/pages/SystemDetail/pages/DeploymentPackages/types'

import { useDpsSubRowsTableColumns } from './useDpsSubRowsTableColumns'

interface DpStructureSubRowsTableProps {
	data: DpObjectContent[]
}

export const DpStructureSubRowsTable = ({
	data,
}: DpStructureSubRowsTableProps) => {
	const columns = useTableColumns({
		tableData: [data ?? []],
		properties: useDpsSubRowsTableColumns(),
	})

	return (
		<Table
			$isSubRowTable
			columns={columns}
			data={data}
			isEditMode={true}
			hasLastRowEdit={false}
			hasLeftAction={false}
			hasDnd={false}
		/>
	)
}
